(() => {
  function setup(root) {
    root.querySelectorAll('.t4s-tab__title').forEach(title => {
      if (title.dataset.nakedReady) return;
      title.dataset.nakedReady = 'true';
      const wrapper = title.closest('.t4s-tab-wrapper');
      const panel = wrapper.querySelector('[data-t4s-tab-content]');
      if (!panel) return;
      title.setAttribute('role', 'button');
      title.setAttribute('aria-controls', panel.id);
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-labelledby', title.id);
      const sync = () => title.setAttribute('aria-expanded', String(wrapper.classList.contains('t4s-active')));
      sync();
      new MutationObserver(sync).observe(wrapper, { attributes: true, attributeFilter: ['class'] });
      title.addEventListener('keydown', event => {
        if (event.key === ' ') { event.preventDefault(); title.click(); }
      });
    });
  }
  function initialize() { document.querySelectorAll('.naked-product-tabs').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();